import React, { useState, useEffect } from "react";
import { Popconfirm, Icon, Card, Row, Col, Tag, Tooltip, message } from "antd";
import moment from "moment";

// Components
import ThreeFigure from "../../components/three-figure";
import Table from "../../components/table";
import Search from "../../components/table/search";
import SearchDates from "../../components/table/searchDates";
import ModalDesingProcess from "../../components/modal-desing-process";
import RenderDesingProcessData from "../../components/render-desing-process-data";

import Colors from "../../theme/colors";

// pages
import DesingProcess from "../design-process";

import { webEntity } from "../../constants";

// Hooks
import useProcessDesings from "../../hooks/useProcessDesings";

// Styles
import { ThreeBox } from "./styles";

//import multilanguage library
import { useTranslation } from "react-i18next";

import { GET_DESIGNS } from "../../operations/queries/designProcess";

import { useQuery } from "@apollo/react-hooks";

const ListDesingProcess = ({ changeTitle }) => {
  const [listOfProcessDesing, setListOfProcessDesing] = useState([]);
  const [selectedProcessDesing, setSelectedProcessDesing] = useState(null);
  const [selectedRowKey, setSelectedRowKey] = useState([]);

  const [designSelected, setDesignSelected] = useState(null);

  const [edit, setEdit] = useState(false);
  const [editDesingEl, setEditDesingEl] = useState({});

  const [showModalDesing, setShowModalDesing] = useState(false);

  const { deleteDesign, getOneDesingData } = useProcessDesings();

  //To translate text
  const { t } = useTranslation();

  //const history = useHistory();
  const { data, refetch, error } = useQuery(GET_DESIGNS(webEntity), {
    notifyOnNetworkStatusChange: true,
  });

  //if (networkStatus === 4) console.log("Refetching!");
  //if (data) console.log(data);
  //if (error) console.log(`Error! ${error}`);

  //Refresh where data exist (on return to page)
  useEffect(() => {
    if (data) refetch();
  }, []);

  //hange title
  useEffect(() => {
    changeTitle && !edit && changeTitle("designs");
  }, [changeTitle, edit]);

  useEffect(() => {
    if (data && data.designs) {
      setListOfProcessDesing(data.designs);
      data.designs[0] && getDataOnRow(data.designs[0]);
    }
  }, [data]);

  const editDesing = async function (row) {
    const response = await getOneDesingData(row);
    setEditDesingEl(response);
    changeTitle("edit_design", row.name);
    setEdit(!edit);
  };

  const deleteDesignProcess = (id) => {
    async function remArticle(id) {
      const response = await deleteDesign(id);
      if (response) {
        message.success(t("alerts.design_removed"));
        //Filter local articles
        let newList = listOfProcessDesing.filter((d) => d.id_design !== id);
        setListOfProcessDesing(newList);

        //Select preview article if exist
        if (newList && newList.length > 0) getDataOnRow(newList[newList.length - 1]);
      } else {
        message.error(t("alerts.design_not_removed"));
      }
    }
    remArticle(id);
  };

  const handleShowModalDesing = (visible) => setShowModalDesing(visible);

  const columns = [
    {
      title: t("table.header.name"),
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "descend",
      ...Search("name"),
    },
    {
      title: t("table.header.article"),
      dataIndex: "id_article.name",
      key: "id_article.name",
      sorter: (a, b) => a.id_article.name.localeCompare(b.id_article.name),
      defaultSortOrder: "descend",
    },
    {
      title: t("table.header.geometry"),
      dataIndex: "id_article.id_article_type.name",
      key: "id_article.id_article_type.name",
      sorter: (a, b) => a.id_article.id_article_type.name.localeCompare(b.id_article.id_article_type.name),
      //...Search("selected_figure"),
      filters: [
        { text: t("geometry.cylinder"), value: "cylinder" },
        { text: t("geometry.rhomboid"), value: "rhomboid" },
        { text: t("geometry.torus"), value: "torus" },
        { text: t("geometry.rectangle"), value: "rectangle" },
      ],
      onFilter: (value, record) => record.id_article.id_article_type.name.toLowerCase().includes(value),
      render: (value) => {
        if (value) return t("geometry." + value.toLowerCase());
        else return "";
      },
    },
    {
      title: t("table.header.type"),
      dataIndex: "id_article.is_prototype",
      key: "is_prototype",
      width: 100,
      render: (is_prototype) => (is_prototype ? t("labels.prototype") : t("labels.catalogue")),
      filters: [
        { text: t("labels.prototype"), value: true },
        { text: t("labels.catalogue"), value: false },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.id_article.is_prototype === value,
    },
    {
      title: t("table.header.design_date"),
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      ...SearchDates("date"),
      render: (date) => moment(date).format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      title: t("table.header.actions"),
      key: "action",
      width: 90,
      render: (text, record) => (
        <Row type="flex" justify="space-between">
          <Tooltip title={record.in_use ? t("button.action.associated_order") : t("button.action.edit", { value: record.name })}>
            <Icon type="edit" onClick={() => !record.in_use && editDesing(record)} style={{ color: record.in_use && "#ccc" }} />
          </Tooltip>
          <Popconfirm
            title={t("button.confirm.delete_design", { value: record.name })}
            okText={t("button.confirm.yes")}
            onConfirm={() => deleteDesignProcess(record.id_design)}
            cancelText={t("button.confirm.no")}
            icon={<Icon type="question-circle-o" style={{ color: Colors.danger }} />}
          >
            <Tooltip title={record.in_use ? t("button.action.associated_order") : t("button.action.delete", { value: record.name })}>
              <Icon type="delete" style={{ color: record.in_use ? "#ccc" : Colors.danger }} />
            </Tooltip>
          </Popconfirm>
        </Row>
      ),
    },
  ];

  // rowSelection objects indicates the need for row selection
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      getDataOnRow(record);
    },
    //no existe en type: radio
    onSelectAll: (selected, selectedRows, changeRows) => {
      //console.log(selected, selectedRows, changeRows);
    },
    type: "radio",
  };

  //const goForward = () => history.goForward();

  const editClose = () => {
    setEdit(false);
    const get_index_selected = listOfProcessDesing.findIndex((e) => e.id_design === selectedRowKey[0]);
    getDataOnRow(data.designs[get_index_selected]);
    //changeTitle("Artículos");
  };

  async function getDataOnRow(row) {
    const response = await getOneDesingData(row);

    setSelectedRowKey([row.id_design]);
    setSelectedProcessDesing(row);

    setDesignSelected(response);
  }

  const clickRow = (row) => {
    getDataOnRow(row);
    //setSelectedRowKey([row.key]);
    //setSelectedProcessDesing(processDesings.find((obj) => obj.id === row.id));
  };

  return edit ? (
    <DesingProcess edit={true} editArticle={editDesingEl.article} editProcess={editDesingEl} back={true} close={editClose} />
  ) : (
    <Row style={{ margin: 0 }} gutter={[16, 16]}>
      <Col xl={16} lg={24}>
        <Table rowKey="id_design" data={listOfProcessDesing} columns={columns} rowSelection={rowSelection} onClick={() => clickRow} />
      </Col>
      <Col xl={8} lg={24}>
        <Card
          title={selectedProcessDesing && selectedProcessDesing.name}
          extra={
            selectedProcessDesing && selectedProcessDesing.id_article && selectedProcessDesing.id_article.is_prototype ? (
              <Tag color="magenta">{t("labels.prototype")}</Tag>
            ) : (
              <Tag color="blue">{t("labels.catalogue")}</Tag>
            )
          }
          cover={
            selectedProcessDesing &&
            selectedProcessDesing.article && (
              <ThreeBox>
                <ThreeFigure
                  figureData={selectedProcessDesing && selectedProcessDesing.article && selectedProcessDesing.article.figure[0]}
                />
              </ThreeBox>
            )
          }
          actions={[
            <span onClick={() => setShowModalDesing(true)}>
              <Icon type="eye" key="eye" /> {t("button.more_info")}
            </span>,
          ]}
        >
          {designSelected && <RenderDesingProcessData selectedProcessDesing={designSelected} />}
        </Card>
      </Col>

      {designSelected && <ModalDesingProcess visible={showModalDesing} handleVisible={handleShowModalDesing} desing={designSelected} />}
    </Row>
  );
};

export default ListDesingProcess;
